import urls from 'constants/urls';
import { type Product } from 'types/adtech';

export const makeBuylistUrl = (products: Product[]) => {
  const lineNumbers = products.map(({ lineNumber }) => lineNumber).join('%2C');

  return `${urls.citrusAdsBuylistPage}/${lineNumbers}`;
};
